let Validator = require('../helpers/validator');

Validator.addRule('br_phones', (value) => {
    return !!/^[0-9]{10,11}$/.exec(value) || !!/^[0-9]{2}\*[0-9]{1,7}\*[0-9]{2,5}$/.exec(value);
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/validators.js